export const IMAGE_SIZE = {
  width: 58,
  height: 43,
} as const;
